import ToggleBox from './ToggleBox.vue';

export default ToggleBox;
